export default "__VITE_ASSET__aEQgWv0w__"